import axios from 'axios';
import { apiUrl } from './apiUrl';

export const isAuthenticated = () => {
    let loginToken = localStorage.getItem('loginToken');
    if (loginToken) {
        return true;
    } else {
        //  window.location.href = "/login";
    }
}

export const authenticate = async (email, password) => {
    return new Promise((resolve, reject) => {
        axios.post(`${apiUrl}/authenticate`, {
            email: email,
            password: password
        }).then(res => {
            localStorage.setItem('loginToken', res.data.token);
            resolve(res.data)
        })
    });
}

export const refreshInfo = async (token) => {
    return new Promise((resolve, reject) => {
        axios.post(`${apiUrl}/refreshinfo`, {
            headers: {
                "Authorization": token
            }
        }).then(res => {
            resolve(res);
        })
    })
}


// WEBPACK FOOTER //
// ./src/baseparking-api/Auth.js